import { useEffect, useState } from 'react';

/**
 * Centralized data handling utility for snapshot components
 * Handles both direct array props and nested data objects
 */
export function useSnapshotData<T>(
  propData: T[] | { data: T[] } | undefined,
  fetchDataFn: () => Promise<void>
) {
  const [data, setData] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleDataInit = async () => {
      // Check if propData has data array with length > 0
      if (propData && typeof propData === 'object' && 'data' in propData && Array.isArray(propData.data) && propData.data.length > 0) {
        // Use data passed as props (nested structure)
        setData(propData.data);
        setLoading(false);
      } else if (propData && Array.isArray(propData) && propData.length > 0) {
        // Fallback: if propData is directly an array
        setData(propData);
        setLoading(false);
      } else {
        // Fallback to fetching data if not provided
        await fetchDataFn();
      }
    };

    handleDataInit();
  }, [propData, fetchDataFn]);

  return { data, setData, loading, setLoading };
}

/**
 * Normalizes snapshot data from various response formats
 */
export function normalizeSnapshotResponse<T>(response: any): T[] {
  return Array.isArray(response) ? response : (response?.data || []);
}
